<div class="placeholder-container">
  <ng-container #placeholder></ng-container>
  <mft-wc-wrapper
    *ngIf="widget.elementName"
    [options]="widgetOptions"
  ></mft-wc-wrapper>
</div>
<markant-callout *ngIf="error" colorScheme="error" theme="colored">
  <div slot="content">
    <div class="content-wrapper">
      <markant-icon icon="m_close-outlined"></markant-icon>
      <p>{{ 'dashboard.cartridge.widget.error' | transloco }}</p>
    </div>
  </div>
</markant-callout>
